export const GET_ORDER_SUPPLIER_REQUEST = 'GET_ORDER_SUPPLIER_REQUEST';
export const GET_ORDER_SUPPLIER_SUCCESS = 'GET_ORDER_SUPPLIER_SUCCESS';
export const GET_ORDER_SUPPLIER_ERROR = 'GET_ORDER_SUPPLIER_ERROR';

export const ADD_ORDER_SUPPLIER_REQUEST = 'ADD_ORDER_SUPPLIER_REQUEST';
export const ADD_ORDER_SUPPLIER_SUCCESS = 'ADD_ORDER_SUPPLIER_SUCCESS';
export const ADD_ORDER_SUPPLIER_ERROR = 'ADD_ORDER_SUPPLIER_ERROR';

export const ADD_ORDER_SUPPLIER_BATCH_REQUEST = 'ADD_ORDER_SUPPLIER_BATCH_REQUEST';
export const ADD_ORDER_SUPPLIER_BATCH_SUCCESS = 'ADD_ORDER_SUPPLIER_BATCH_SUCCESS';
export const ADD_ORDER_SUPPLIER_BATCH_ERROR = 'ADD_ORDER_SUPPLIER_BATCH_ERROR';

export const UPDATE_ORDER_SUPPLIER_REQUEST = 'UPDATE_ORDER_SUPPLIER_REQUEST';
export const UPDATE_ORDER_SUPPLIER_SUCCESS = 'UPDATE_ORDER_SUPPLIER_SUCCESS';
export const UPDATE_ORDER_SUPPLIER_ERROR = 'UPDATE_ORDER_SUPPLIER_ERROR';

export const DELETE_ORDER_SUPPLIER_REQUEST = 'DELETE_ORDER_SUPPLIER_REQUEST';
export const DELETE_ORDER_SUPPLIER_SUCCESS = 'DELETE_ORDER_SUPPLIER_SUCCESS';
export const DELETE_ORDER_SUPPLIER_ERROR = 'DELETE_ORDER_SUPPLIER_ERROR';

export const GET_ORDER_SUPPLIER_DROPDOWN_REQUEST = 'GET_ORDER_SUPPLIER_DROPDOWN_REQUEST';
export const GET_ORDER_SUPPLIER_DROPDOWN_SUCCESS = 'GET_ORDER_SUPPLIER_DROPDOWN_SUCCESS';
export const GET_ORDER_SUPPLIER_DROPDOWN_ERROR = 'GET_ORDER_SUPPLIER_DROPDOWN_ERROR';

export const GET_ORDER_DROPDOWN_REQUEST = 'GET_ORDER_DROPDOWN_REQUEST';
export const GET_ORDER_DROPDOWN_SUCCESS = 'GET_ORDER_DROPDOWN_SUCCESS';
export const GET_ORDER_DROPDOWN_ERROR = 'GET_ORDER_DROPDOWN_ERROR';
